<div class="grid">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoListar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoListar">
			<div class="formgroup" *ngIf="permissaoInserir">
				<div class="p-fluid p-formgrid grid">
					<div class="field col-12 md:col-2">
						<button pButton pRipple routerLink="/apps/grupo/inserir" label="Novo" icon="pi pi-plus"
							class="p-button-outlined sm:w-9rem"></button>
					</div>
				</div>
			</div>
			<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
				<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
			</div>
			<p-table #dt1 [value]="grupos" dataKey="id" [rows]="10" [loading]="loadingGrupos" [rowHover]="true"
				[paginator]="true" [globalFilterFields]="['descricao', 'planoContaEmpresa.descricao']"
				responsiveLayout="stack" styleClass=" p-datatable-sm">
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
						<p-dropdown class="p-fluid w-full sm:w-auto sm:mr-2" [options]="tiposGrupo" optionLabel="label"
							optionValue="value" emptyFilterMessage="Nenhum registro" name="situacao" ngModel
							#situacao="ngModel" [(ngModel)]="tipoGrupoSelecionado" (onChange)="listarGrupos()">
						</p-dropdown>

						<div class="p-fluid w-full sm:w-auto mt-2 sm:mt-0">
							<div class="flex">
								<span class="p-input-icon-left">
									<i class="pi pi-search"></i>
									<input pInputText type="text" #filter (input)="buscar(dt1, $event)"
										placeholder="Buscar" class="w-full" />
								</span>
								<span class="ml-2">
									<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
										pTooltip="Limpar Filtros" (click)="limpar(dt1)"></button>
								</span>
							</div>
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
						<th pSortableColumn="descricao">
							Descricão
							<p-sortIcon field="descricao">
							</p-sortIcon>
						</th>
						<th pSortableColumn="planoContaEmpresa.descricao">
							Tipo
							<p-sortIcon field="planoContaEmpresa.descricao">
							</p-sortIcon>
						</th>

						<th style="text-align: center;">
							<div *ngIf="verificarPermissao('PERM_DETALHAR_GRUPO') ||
							verificarPermissao('PERM_EDITAR_GRUPO') ||
							verificarPermissao('PERM_EXCLUIR_GRUPO')">
								Ações
							</div>
						</th>

					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-grupo>
					<tr>

						<td>
							{{grupo.descricao}}
						</td>
						<td>
							{{grupo.planoContaEmpresa?.descricao}}
						</td>

						<td style="text-align: center;">
							<div>
								<button *ngIf="verificarPermissao('PERM_DETALHAR_GRUPO')"
									(click)="detalharGrupo(grupo.id)" pButton pRipple pTooltip="Detalhar"
									icon="pi pi-eye" class="p-button-info mr-2 mb-2"></button>
								<button *ngIf="verificarPermissao('PERM_EDITAR_GRUPO')" (click)="editarGrupo(grupo.id)"
									pButton pRipple pTooltip="Editar" icon="pi pi-pencil"
									class="p-button-success mr-2 mb-2"></button>
								<button *ngIf="verificarPermissao('PERM_EXCLUIR_GRUPO')" pButton pRipple
									pTooltip="Excluir" icon="pi pi-trash" class="p-button-danger mr-2 mb-2 sm"
									(click)="excluirGrupo(grupo.id)"></button>
							</div>

						</td>

					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Nenhum registro encontrado.</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Carregando grupos. Por favor aguarde.</td>
					</tr>
				</ng-template>
			</p-table>
			<p-confirmDialog [style]="{width: '50vw'}">
			</p-confirmDialog>
		</div>
	</div>
</div>